import React, { useState } from 'react'
import QuestionLanguageVarient from './QuestionLanguageVarient'
import renderHTML, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from "react-html-parser";
// import Editor from 'ckeditor5-custom-build/build/ckeditor'

import Editor from "@ckeditor/ckeditor5-build-classic";
// import {Editor as ClassicEditor } from 'ckeditor5-custom-build/build/ckeditor'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import ClipLoader from "react-spinners/ClipLoader";
import Modal from 'react-bootstrap/Modal'
import { changeTextUsingOpenAi, updateQuestionOptionConvertedValue } from '../../../api/testSeries/testseries';
import CKEditorImageUpload from '../../../Utils/CKEditorImageUpload';

function Option({ item, index, correctPrompt, showConvertOption }) {



  const [openOptionModal, setOpenOptionModal] = useState(false)
  const [convertingLoader, setConvertingLoader] = useState(false)
  const [updatingConvertedLoader, setUpdatingConvertedLoader] = useState(false)
  const [convertedOption, setConvertedOption] = useState()


  // console.log("item:  ", item)
  const handleConvertQption = async (e) => {
    e.preventDefault()
    setUpdatingConvertedLoader(true)
    const response = await updateQuestionOptionConvertedValue({ convertedValue: convertedOption, id: item.id })
    if (response.status) {
      item.convertedValue = convertedOption
      // console.log(item)
      setOpenOptionModal(false)

    }
    setUpdatingConvertedLoader(false)
  }

  const checkConvertedOptionHandler = async () => {
    setConvertingLoader(true)
    const response = await changeTextUsingOpenAi(item?.value, "Rewrite this ")
    if (response?.status) {
      setConvertedOption(response?.data?.content)
    }
    setConvertingLoader(false)
  }

  return (

    <div className="row mr-4">
      <div className="col-10">
        {showConvertOption ? (
          <div className="mt-1 mb-1 mr-1 p-1" style={{ borderStyle: "solid", borderWidth: 1, borderColor: (correctPrompt === item?.prompt && item?.isCorrect) ? "#7859c5" : "#838383", borderRadius: 10 }}>
            {renderHTML(item?.value || '')}

          </div>
        ) : (
          <div className="mt-1 mb-1 mr-1 p-1" style={{ borderStyle: "solid", borderWidth: 1, borderColor: (correctPrompt === item?.prompt && item?.isCorrect) ? "#7859c5" : "#838383", borderRadius: 10 }}>
            {renderHTML(item?.convertedValue || '')}
          </div>
        )}

      </div>
      {/* {showConvertOption ? (<div className="col-2">
        <button type="button" class="btn btn-success ml-2 mr-1 mt-2" onClick={() => {
          setOpenOptionModal(true)
          setConvertedOption(item?.convertedValue)
        }}>
          Convert
        </button>
      </div>) : (null)} */}

      <Modal
        show={openOptionModal}
        onHide={() => setOpenOptionModal(false)}
        aria-labelledby="example-modal-sizes-title-lg"
        style={{ zIndex: 10000 }}
      >
        <form onSubmit={handleConvertQption}>
          <Modal.Header closeButton>
            <h5 className="modal-title">Convert optionView</h5>
          </Modal.Header>
          <Modal.Body>
            <div>

              <div className="form-row">
                <div className="col-12">
                  <label>Original optionView</label>
                  <CKEditor
                    editor={Editor}
                    data={item?.value}
                    disabled={true}
                    onChange={(event, editor) => {

                    }}
                  />
                </div>
                <button type="button" class="btn btn-success ml-2 mr-1 mt-2" onClick={() => { checkConvertedOptionHandler() }}>
                  {convertingLoader ? (
                    <ClipLoader color="white" loading={convertingLoader} size={20} />
                  ) : ("Convert optionView")}

                </button>
              </div>
              <div className="form-row">
                <div className="col-12">
                  <label>Converted optionView</label>
                  <CKEditor
                    editor={Editor}
                    data={convertedOption}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      setConvertedOption(data)
                    }}
                    config={{
                      extraPlugins: [CKEditorImageUpload]
                    }}
                  />
                </div>

              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <button type="button" onClick={() => setOpenOptionModal(false)} className="btn btn-secondary" data-dismiss="modal">Close</button>
            <button className="btn btn-primary" disabled={updatingConvertedLoader}>
              {updatingConvertedLoader ? (
                <ClipLoader color="white" loading={updatingConvertedLoader} size={20} />
              ) : ("Save Converted Option")}
            </button>
          </Modal.Footer>
        </form>



      </Modal>
    </div>


  )
}

export default Option